<template>
  <section class="layout-section -alt-top">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Tags & Icônes</h2>
      <p>
        Les tags et les icônes jouent un rôle clé dans l’interface : ils permettent de repérer rapidement l’information,
        de catégoriser les contenus et de faciliter la navigation. Ils guident l’utilisateur visuellement tout en
        renforçant la hiérarchie de l’information.
      </p>
    </div>

    <article class="layout-tag">
      <div class="tag">Tous les tags</div>
      <div class="tag -light">Articles</div>
      <div class="tag -light">Rapports</div>
      <div class="tag -light">Rapports annuels</div>
      <div class="tag -light">Dossiers thématiques</div>
      <div class="tag -light">...</div>
    </article>

    <article class="layout-tag">
      <div class="tag -small">
        <SvgIcon id="content-article" />
        Article
      </div>

      <div class="tag -small">
        <SvgIcon id="content-rapport" />
        Rapport annuel
      </div>

      <div class="tag -small">
        <SvgIcon id="content-folder" />
        Dossier thématique
      </div>

      <div class="tag -small">
        <SvgIcon id="content-date" />
        Évènement
      </div>

      <div class="tag -small">
        <SvgIcon id="content-web" />
        Webinaire
      </div>

      <div class="tag -small">
        <SvgIcon id="content-trophy" />
        Remise de prix
      </div>
    </article>
  </section>
</template>

<script>
export default {
  name: 'DemoTag'
}
</script>
